import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import {
    SharedAddCommentDialogData,
    SharedCommentsResult
} from 'src/app/_shared/dialogs/shared-add-comment-dialog/shared-add-comment-dialog.component';

export interface SharedAddCommentContainerDialogData {
    commentsList: {
        id: string;
        label: string;
        comment: SharedAddCommentDialogData;
    }[];
}

@Component({
    selector: 'app-shared-add-comment-container-dialog',
    templateUrl: './shared-add-comment-container-dialog.component.html',
    styleUrls: ['./shared-add-comment-container-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAddCommentContainerDialogComponent extends SharedCommentsResult implements OnInit {

    commentsList: SharedAddCommentContainerDialogData;

    commentControl: UntypedFormControl;

    form: UntypedFormGroup;

    constructor(private readonly dialogRef: KalDialogRef<SharedAddCommentContainerDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedAddCommentContainerDialogData,
                private readonly fb: UntypedFormBuilder) {
        super();
    }

    get commentsListControls(): UntypedFormControl[] {
        return (this.form.get('commentsList') as UntypedFormArray).controls as UntypedFormControl[];
    }

    submit(): void {
        const updatedComment = this.form.get('commentsList').value.map(e => {
            const commentResult = e.commentResult;
            commentResult.publicComment = e.comment.publicComment;
            commentResult.privateComment = e.comment.privateComment;

            return {
                ...e,
                comment: commentResult
            };
        });

        const saveComment = {commentsList: updatedComment};

        this.dialogRef.close(saveComment);
    }

    cancel(): void {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            commentsList: this.fb.array([])
        });

        this.data.commentsList.forEach(e => {
            (this.form.get('commentsList') as UntypedFormArray).push(this.fb.group({
                id: e.id,
                label: e.label,
                comment: e.comment,
                commentResult: new SharedCommentsResult(e.comment?.publicComment, e.comment?.privateComment, e.comment?.scope)
            }));
        });
    }

}
